




















































































































































































































































































import { Component, Prop, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { InputCode } from '@/components/molecules/InputCode'
import { Col, DataTable } from '@/components/molecules/DataTable'
import { InputCodeTrader } from '@/components/molecules/InputCodeTrader'
import { InputCodeDonor } from '@/components/molecules/InputCodeDonor'
import {
  defaultSystemCode,
  Donor,
  SystemCode,
  systemCodeApi,
  SystemCodeWithKey,
  Trader
} from '@/api'
import { CODE_KEY } from '@/config'

export interface InputBookNumberTableItem {
  branchCode: SystemCode
  holdingCount: number
  orderCount: number
  acceptPrice: number
  number: {
    input: string
    errorMessage: string
  }
  traderCode: {
    input: string
    shortName: string
    errorMessage: string
  }
  acceptType: {
    input: string
    shortName: string
    errorMessage: string
  }
  buyDepartmentCode: {
    input: string
    shortName: string
    errorMessage: string
  }
  donorCode: {
    input: string
    shortName: string
    errorMessage: string
  }
  budgetYear: {
    input: string
    errorMessage: string
  }
  budgetBranchCode: {
    input: string
    shortName: string
    errorMessage: string
  }
  budgetDepartmentCode: {
    input: string
    shortName: string
    errorMessage: string
  }
  budgetExpenseCode: {
    input: string
    shortName: string
    errorMessage: string
  }
  equipType: {
    input: string
    shortName: string
    errorMessage: string
  }
  collectionType: {
    input: string
    shortName: string
    errorMessage: string
  }
  appendixCode: {
    input: string
    shortName: string
    errorMessage: string
  }
}

export const defaultInputBookNumberTableItem = (): InputBookNumberTableItem => ({
  branchCode: defaultSystemCode(),
  holdingCount: 0,
  orderCount: 0,
  acceptPrice: 0,
  number: {
    input: '',
    errorMessage: ''
  },
  traderCode: {
    input: '',
    shortName: '',
    errorMessage: ''
  },
  acceptType: {
    input: '',
    shortName: '',
    errorMessage: ''
  },
  buyDepartmentCode: {
    input: '',
    shortName: '',
    errorMessage: ''
  },
  donorCode: {
    input: '',
    shortName: '',
    errorMessage: ''
  },
  budgetYear: {
    input: '',
    errorMessage: ''
  },
  budgetBranchCode: {
    input: '',
    shortName: '',
    errorMessage: ''
  },
  budgetDepartmentCode: {
    input: '',
    shortName: '',
    errorMessage: ''
  },
  budgetExpenseCode: {
    input: '',
    shortName: '',
    errorMessage: ''
  },
  equipType: {
    input: '',
    shortName: '',
    errorMessage: ''
  },
  collectionType: {
    input: '',
    shortName: '',
    errorMessage: ''
  },
  appendixCode: {
    input: '',
    shortName: '',
    errorMessage: ''
  }
})

@Component({
  components: {
    InputCodeDonor,
    InputCodeTrader,
    DataTable,
    InputCode
  }
})
export default class InputBookNumberTable extends ComponentVue {
  @PropSync('items', {
    type: Array,
    required: true
  })
  tableItems!: InputBookNumberTableItem[]

  @Prop({
    type: Number
  })
  height!: number

  @Prop({
    type: Boolean,
    default: false
  })
  isOrder!: boolean

  // 通常のSystemCode取得しようでは無駄なリクエストが増える為、下記のように対応
  get acceptTypeSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.ACCEPT_TYPE.KEY)
  }

  get departmentSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.DEPARTMENT.KEY)
  }

  get libraryBranchSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.LIBRARY_BRANCH.KEY)
  }

  get expenseSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.EXPENSE.KEY)
  }

  get equipmentConsumableTypeSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(
      CODE_KEY.EQUIPMENT_CONSUMABLE_TYPE.KEY
    )
  }

  get collectionTypeSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.COLLECTION_TYPE.KEY)
  }

  get appendixSystemCode(): Promise<SystemCodeWithKey> {
    return systemCodeApi.getSystemCodeWithKey(CODE_KEY.APPENDIX.KEY)
  }

  get cols(): Col[] {
    return [
      {
        width: '6',
        resizable: true,
        items: [
          {
            name: 'branchCode',
            headerText: '館'
          }
        ]
      },
      {
        width: '4',
        resizable: true,
        items: [
          {
            name: 'holdingCount',
            headerText: '所蔵済'
          }
        ]
      },
      {
        width: '4',
        resizable: true,
        items: [
          {
            name: 'orderCount',
            headerText: '発注中'
          }
        ]
      },
      {
        width: '6',
        resizable: true,
        required: true,
        items: [
          {
            name: 'number',
            headerText: `${this.isOrder ? '発注' : '登録'}冊数`
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        items: [
          {
            name: 'traderCode',
            headerText: '購入業者'
          }
        ]
      },
      {
        width: '6',
        resizable: true,
        items: [
          {
            name: 'acceptType',
            headerText: '受入区分'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        items: [
          {
            name: 'buyDepartmentCode',
            headerText: '購入部署'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        items: [
          {
            name: 'donorCode',
            headerText: '寄贈者'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        required: true,
        items: [
          {
            name: 'budgetYear',
            headerText: '予算年度'
          }
        ]
      },
      {
        width: '6',
        resizable: true,
        required: true,
        items: [
          {
            name: 'budgetBranchCode',
            headerText: '予算館'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        items: [
          {
            name: 'budgetDepartmentCode',
            headerText: '予算部署'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        items: [
          {
            name: 'budgetExpenseCode',
            headerText: '予算費目'
          }
        ]
      },
      {
        width: '6',
        resizable: true,
        items: [
          {
            name: 'equipType',
            headerText: '備消'
          }
        ]
      },
      {
        width: '8',
        resizable: true,
        items: [
          {
            name: 'collectionType',
            headerText: '資料区分'
          }
        ]
      },
      {
        width: '6',
        resizable: true,
        items: [
          {
            name: 'appendixCode',
            headerText: '付録'
          }
        ]
      }
    ]
  }

  get numberMask(): string {
    return '#'.repeat(3)
  }

  get budgetYearMask(): string {
    return '#'.repeat(4)
  }

  existsErrorMessage(errorMessage: string): boolean {
    return !!errorMessage
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  setShortName(obj: any, systemCode: SystemCode | Trader | Donor): void {
    obj.shortName = systemCode.shortName
  }
}
